export const timeZoneOptions = [
  {
    label: "(UTC-12:00) International Date Line West",
    offset: "-12:00",
    key: "Etc/GMT+12",
  },
  {
    label: "(UTC-11:00) American Samoa",
    offset: "-11:00",
    key: "Pacific/Pago_Pago",
  },
  { label: "(UTC-10:00) Hawaii", offset: "-10:00", key: "Pacific/Honolulu" },
  { label: "(UTC-09:00) Alaska", offset: "-09:00", key: "America/Anchorage" },
  {
    label: "(UTC-08:00) Pacific Time (US & Canada)",
    offset: "-08:00",
    key: "America/Los_Angeles",
  },
  {
    label: "(UTC-07:00) Mountain Time (US & Canada)",
    offset: "-07:00",
    key: "America/Denver",
  },
  {
    label: "(UTC-06:00) Central Time (US & Canada)",
    offset: "-06:00",
    key: "America/Chicago",
  },
  {
    label: "(UTC-05:00) Eastern Time (US & Canada)",
    offset: "-05:00",
    key: "America/New_York",
  },
  {
    label: "(UTC-04:00) Atlantic Time (Canada)",
    offset: "-04:00",
    key: "America/Halifax",
  },
  {
    label: "(UTC-03:00) Buenos Aires",
    offset: "-03:00",
    key: "America/Argentina/Buenos_Aires",
  },
  { label: "(UTC-02:00) Mid-Atlantic", offset: "-02:00", key: "Etc/GMT+2" },
  { label: "(UTC-01:00) Azores", offset: "-01:00", key: "Atlantic/Azores" },
  { label: "(UTC+00:00) UTC / GMT", offset: "00:00", key: "UTC" },
  {
    label: "(UTC+01:00) Central Europe (Paris, Berlin)",
    offset: "+01:00",
    key: "Europe/Paris",
  },
  {
    label: "(UTC+02:00) Eastern Europe (Athens, Bucharest)",
    offset: "+02:00",
    key: "Europe/Bucharest",
  },
  {
    label: "(UTC+03:00) Moscow, Nairobi",
    offset: "+03:00",
    key: "Europe/Moscow",
  },
  { label: "(UTC+03:30) Tehran", offset: "+03:30", key: "Asia/Tehran" },
  {
    label: "(UTC+04:00) Abu Dhabi, Baku",
    offset: "+04:00",
    key: "Asia/Dubai",
  },
  { label: "(UTC+04:30) Kabul", offset: "+04:30", key: "Asia/Kabul" },
  {
    label: "(UTC+05:00) Islamabad, Karachi",
    offset: "+05:00",
    key: "Asia/Karachi",
  },
  {
    label: "(UTC+05:30) India Standard Time",
    offset: "+05:30",
    key: "Asia/Kolkata",
  },
  { label: "(UTC+06:00) Dhaka", offset: "+06:00", key: "Asia/Dhaka" },
  {
    label: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
    offset: "+07:00",
    key: "Asia/Bangkok",
  },
  {
    label: "(UTC+08:00) Beijing, Singapore, Perth",
    offset: "+08:00",
    key: "Asia/Shanghai",
  },
  { label: "(UTC+09:00) Tokyo, Seoul", offset: "+09:00", key: "Asia/Tokyo" },
  {
    label: "(UTC+09:30) Adelaide",
    offset: "+09:30",
    key: "Australia/Adelaide",
  },
  {
    label: "(UTC+10:00) Sydney, Guam",
    offset: "+10:00",
    key: "Australia/Sydney",
  },
  {
    label: "(UTC+11:00) Solomon Islands",
    offset: "+11:00",
    key: "Pacific/Guadalcanal",
  },
  {
    label: "(UTC+12:00) Auckland, Fiji",
    offset: "+12:00",
    key: "Pacific/Auckland",
  },
  {
    label: "(UTC+13:00) Tonga, Phoenix Islands",
    offset: "+13:00",
    key: "Pacific/Tongatapu",
  },
];
